import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	container: {
		display: "flex"
	}
})

export default useStyles
